import { gql } from 'urql';
import { OwnerFragment } from './ownerFragment';

export const RealEstateFragment = gql`
  ${OwnerFragment}
  fragment RealEstateFragment on RealEstate {
    id
    name
    notes
    householdID
    __typename
    changeToken
    realEstateType
    address {
      street1
      street2
      city
      state
      country
      postalCode
    }
    ownedValue {
      __typename
      value
      currencyCode
    }
    ownership {
      __typename
      ... on TenantsInCommon {
        interests {
          owner {
            ...OwnerFragment
          }
          percentage
        }
      }
    }
    value {
      id
      tenantID
      updatedAt
      latestDataPoint {
        id
        dateTime
        data {
          __typename
          ... on MonetaryAmountDataPointValue {
            value {
              currencyCode
              value
            }
          }
        }
      }
      dataPoints {
        items {
          id
          dateTime
          data {
            __typename
            ... on MonetaryAmountDataPointValue {
              value {
                currencyCode
                value
              }
            }
          }
        }
      }
    }
  }
`;
